export default {
  overrides: {
    MuiCssBaseline: {
      body: {
        fontFamily: '"Helvetica Neue", Arial, sans-serif',
      },
    },
  },
};